let styles = {
  header: {
    'background-color': '#eee',
    'padding': '10px',
    'display': 'flex',
    'justify-content': 'space-between'
  },

  button: {
    'display': 'inline-block',
    'margin-left': '10px'
  }
}

export default styles